<template>
  <detail-card v-if="reservation"
               type="reservation"
               :data="reservation"
               v-bind="$attrs">
    <template v-slot:header>{{ reservation.number }}</template>
    <template v-slot:body>
      <prop name="Datum">
        <div v-if="!movingReservation">
          <span>{{ reservation.startTime | dateTime }}</span>
          <font-awesome-icon :icon="['far', 'edit']" class="fa-edit ml-2 link" fixed-width size="1x"
                             @click="movingReservation = true"/>
        </div>
        <div v-else>
          <div>
            <label for="#startTimeInput">Neue Startzeit und -datum</label>
            <input id="startTimeInput"
                   type="datetime-local"
                   class="form-control"
                   v-model="editedStartTime">
          </div>
          <div class="mt-2">
            <label for="#durationInput">Neue Dauer in Stunden</label>
            <input id="durationInput" type="number"  class="form-control" v-model="editedDuration">
          </div>
          <div class="d-flex mt-3">
            <button class="btn btn-sm btn-danger"
                    @click="movingReservation = false">
              Abbrechen
            </button>
            <button class="btn btn-sm btn-success ml-1" @click="moveReservation">Speichern</button>
          </div>
        </div>
      </prop>
      <prop name="Erstellt">{{ reservation.createdTime | dateTime }}</prop>
      <prop name="verfällt" v-if="reservation.state !== 'confirmed'">{{
          reservation.expirationDate | date
        }}
      </prop>
      <prop name="Status">{{ reservation.state }}</prop>
      <prop name="Erlebnis" v-if="reservation.product">{{ reservation.product.name }}</prop>
      <prop v-else name="Erlebnis" class="text-danger">kein Produkt mit Reservierung verknüpft</prop>
      <prop name="Dauer">{{ reservation.duration }}h</prop>
      <prop name="Teilnehmer">{{ reservation.attendees }}</prop>
    </template>
  </detail-card>
</template>
<script>
import DetailCard from "@/layouts/DetailCard";
import Prop from "@/layouts/Prop";

export default {
  props: {
    reservation: Object
  },
  data() {
    return {
      editedStartTime: this.reservation.startTime,
      editedDuration: this.reservation.duration,
      movingReservation: false
    }
  },
  methods: {
    moveReservation() {
      this.$api.put(`/reservations/${this.reservation.number}`, {
        ...this.reservation,
        startTime: this.editedStartTime,
        duration: this.editedDuration
      }, {
        params: {
          command: 'move'
        }
      }).then(res => {
        this.showInfo("Die Reservierung wurde verschoben.")
        this.movingReservation = false
        this.reservation = res.data
      }).catch(err => this.handleError(err))
    },
  },
  watch: {
    reservation: {
      handler(newVal) {
        if (newVal) {
          this.editedStartTime = newVal.startTime.startOf("minute").toISO({
            includeOffset: false,
            suppressSeconds: true,
            suppressMilliseconds: true
          })
          this.editedDuration = newVal.duration
        }
      },
      immediate: true
    }
  },
  components: {DetailCard, Prop}
}
</script>
